export default __webpack_public_path__ + "static/media/grid.005.bdb85efc.jpeg";